module.exports = __webpack_public_path__ + "static/media/tecnologia.f3c8fa12.png";